// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"9ceac1b9","928":"f55ae075"}[chunkId] + ".chunk.css";
};